module.exports = __webpack_public_path__ + "img/index_order_bg.519e2235.jpg";